var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-currency-field',_vm._g(_vm._b({ref:"currencyField",staticClass:"text-capitalize",attrs:{"dense":"","suffix":_vm.currency,"label":_vm.$t(_vm.label),"value":_vm.value,"rules":_vm.rules},on:{"keydown":_vm.blurWhenEnter}},'v-currency-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }